// RootLayout.tsx
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './components/common/Header';

const RootLayout: React.FC = () => {
    const location = useLocation();

    // Показывать Header, если текущий маршрут не /login
    const showHeader: boolean = location.pathname !== '/login';

    return (
        <main
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}

        >
            {showHeader && <Header />}
            <div  style={{
                flex: 1,         // занимать всё оставшееся пространство
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,    // чтобы вложенные элементы могли растягиваться
                padding: '1rem', // или ваш класс "m-5", как хотите
            }}
            >
                <Outlet />
            </div>
        </main>
    );
};

export default RootLayout;
